import PropTypes from 'prop-types';
import Link from 'next/link';
import Title from 'components/title/title.jsx';
import { TitleHeader, Categories, Counter } from './filter.css.js';
import { ContentDetails } from 'components/layout/layout.css.js';
const filters = [{
  title: 'All',
  href: '/'
}, {
  title: 'Travel',
  href: '/travel'
}, {
  title: 'Tech',
  href: '/tech'
}];
const normalizePath = p => {
  // Strip query string and hash, then remove trailing slash
  const pathOnly = p.split('?')[0].split('#')[0];
  return pathOnly.replace(/\/$/, '') || '/';
};
const Filter = ({
  path,
  title,
  displayCount,
  totalCount
}) => <ContentDetails>
    <TitleHeader>
      <Title as="h1" size="large">
        {title}
      </Title>
      <Categories>
        {filters.map(({
        href,
        title
      }) => <Link key={href} href={href} className={normalizePath(path) === normalizePath(href) ? 'active' : ''}>
            {title}
          </Link>)}
      </Categories>
    </TitleHeader>
    <Counter>
      Loaded {displayCount} of {totalCount} posts
    </Counter>
  </ContentDetails>;
Filter.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  displayCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired
};
export default Filter;